import React, { useEffect, useRef } from 'react'; //see line 14
import { connect } from 'react-redux';
import { dropdownOpen } from '../../actions';



//import { dropdownSelection } from '../../actions';   see '***'

//see udemy, understanding hooks Why is this hard tutorial. THERE IS NO WAY I WILL REMEBER THE SERIES OF THINGS
//GOING ON WHEN YOU CLICK ON THE DROP DOWN. YOU NEED TO RE_WATCH THE UDEMY TUTORIAL.
//Drop down is unbelievably complicated to understand how to make it close up properly.
//The drop down should close up ONLY if you make a selection Or click outside the dropdown.
//We can figure out that a click has happened outside the dropdown by using the useRef hook.
//so look at the <div ref={ref} className="ui container form"> that is returned down below. The ref provides us a way
//to look at the highest most parent element of the dropdown component, and then decide if a child 'target' was clicked.
//So 'current.contains' is used to find out did we click inside the dropdown. event.target will be somewhere inside
//the drop down. 
const Dropdown = (props) => {
    const ref = useRef();
    //the so called 'hooks' useEffect function
    useEffect(() => {

        //alert('useEffect entered with isDropdownOpen = ' + props.isDropdownOpen);
        //this event becomes registered by statement below, and is waiting from then on to be executed.
        const onBodyClick = (event) => {
            //console.log("2");
            //alert("onBodyClick");
            //yes this is complicated! This code is trying to find out if we clicked outside the dropdown component.
            //Example of a null problem. . .
            //There are two ways that onBodyClick gets called:
            //1) anytime you click on the dropDown element.
            //2) anytime you click outside the drop down element.
            //    1) by clicking on a navigation link to go to another component (hence causing the drop down component to unmount and become null)
            //    2) by clicking somewhere outside the drop down component but not navigating away from the drop down component. (hence the drop down element is still active)
            //This onBodyClick event handler executes props.dropdownOpen(false) which then closes the dropdown.
            //If you clicked a different navigation link (which is still a body click), hence going away from the dropdown which causes the drop down to unmount. 
            //That means the ref is null now, which will throw an error if ref.current.contains(event.target) is executed.
            //So that is why !ref.current null check is needed, (and mentioned first) to avoid the null error since we clicked a navigation link. You will NOT need !ref.current for times when you
            //click inside the dropdown element, (or outside the drop down element but did not navigate away from drop down) since the dropdown is still visibly loaded on the screen.
            //ref.current gets ref set to null if we removed the dropDown component, which would then cause this code to break if it executes when the dropdown
            // is not showing.  This event handler was registered, so it will run even if the dropdown is unmounted.
            // This line is more explicit than . . .
            //if (ref.current == null || ref.current.contains(event.target)) {
            // Less explicit . . .
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            //invoke action creator to turn state to 'off' if the user clicked outside of the drop down.
            //alert("clicked outside of dropdownOpen ");
            //alert("Current state of isDropdownOpen I expect to be open " + props.isDropdownOpen);
            //alert("so now I want to change isDropdownOpen to  false, and re-render");
            props.dropdownOpen(false);
        };
        //note : this is normal javascript, not React
        //also note, this event listener comes first in the bubble up because it was manually assigned which takes precedense (as opposed to natural click event)
        //alert("register onBodyClick NOW" );
        document.body.addEventListener('click', onBodyClick);
        //THERE ARE TWO POINTS IN TIME THAT THIS 'CLEANUP' CODE IS EXECUTED!
        //1) Whenever the useEffect runs Next Time, cleanup code runs first
        //2) Whenever the dropDown component is removed, cleanup code will run. Just like if it was componentDidUnmount life cycle method. Wow. I did not know that.

        //The clean up functions only purpose is to prevent creating multiple event registrations of the onBodyClick handler!
        //The clean up function has nothing to do with dealing with the ref hook null issue.
        //This cleanup code is necessary because we want to avoid multiple registration on the event handler. It will 'de-register' the event handler.
        //this cleanup routine is 'registered' the first time useEffect executes, but does not execute until later. It is waiting to be executed the very next time useEffect next executes.
        //This clean-up will then execute 'first thing' when useEffect next executes. In this way, we prevent all kinds of problems, such as multiple event registration etc.
        return () => {
            //alert("onBodyClick cleanup props.isDropdownOpen : " + props.isDropdownOpen);
            //alert("de-register onBodyClick");
            //console.log("1");
            //console.log("registered cleanup");
            document.body.removeEventListener('click', onBodyClick);
        };
        // with [props] as second argument, useEffect only runs one time, however, from that 'one time, the onBodyClick gets registered and is being listened for!
        // but the props can change by causing state to change, this component will re-render, which is neccessary to reflect whatever change happened, props.dropdownOpen(false) and so if the props change, useEffect gets run again
    }, [props]);

    const dropdownOpen = () => {
        //alert("entered dropdownOpen after clicking dropdown ");
        //alert("Current state of isDropdownOpen " + props.isDropdownOpen);


        //anytime you click the drop down, you will be openning it if it is closed (to make a selection),
        // or you will be closing it (by making a selection) if it is open.
        //So this action will cause a state change, which will cause all components to re-render, so Dropdown gets re-rendered all over again.
        props.dropdownOpen(!props.isDropdownOpen);
    };



    //
    // '***' Observation: Notice that I am using onClick to pass back the selected option to the onSelectedChange callback that can be found on Images.js.
    //So, I was wonderring why don't I just call the props.mydropdownSelection(option) action from here on imagesDropdownNav rather than on Images.js.
    //It turns out that I can. So is there ever a reason to send data back to a call back like I tend to do?
    //I have included the code changes commented out here to prove it works.
    const renderedOptions = () => {
        return props.options.map((option) => {
            //this skips the selected item from appearing in the dropdown list since it is already selected
            if (option.value === props.dropdownSelection) { return null; }
            return (
                <div key={option.value}
                    className="item"
                    onClick={() => props.onSelectedChange(option.value)}>{/* this will invoke setSelected on Images.js passing back this option*/}
                    {/* see '***' onClick={() => props.mydropdownSelection(option.value)}> */}
                    {option.label}
                </div>
            );
        });
    }

    //console.log(ref.current);
    //This stuff here makes up the drop down mechanism.
    // 'visible active' and 'visible transition' must be present as the class in order for the drop down to appear 'open'
    return (
        <div style={{ width: '300px' }} ref={ref} className="ui container form">
            <div className="field">
                <label style={{ width: '200px' }} className="label">{props.label}</label>
                <div
                    onClick={() => dropdownOpen()}
                    className={`ui selection dropdown ${props.isDropdownOpen ? ' visible active' : ""}`}>
                    <i className="dropdown icon"></i>
                    <div className="text">{props.dropdownSelection}</div>
                    <div className={`menu ${props.isDropdownOpen ? ' visible transition' : ''}`}>{renderedOptions()}</div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return { dropdownSelection: state.dropdownSelection.selection, isDropdownOpen: state.dropdownIsOpen.isOpen };
}
//NOTE action creator included here
export default connect(mapStateToProps, { dropdownOpen: dropdownOpen })(Dropdown);

// see '***' export default connect(mapStateToProps, { dropdownOpen: dropdownOpen, mydropdownSelection: dropdownSelection})(Dropdown);